import {
  initialState,
  Actions,
  State,
  GET_PERIODICS_CHECKS_METRICS,
  GET_PERIODICS_CHECKS_METRICS_SUCCESS,
  GET_PERIODICS_CHECKS_METRICS_ERROR,
  RESET_GET_PERIODICS_CHECKS_METRICS,
} from '../../types/periodic-check/get-metrics'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_PERIODICS_CHECKS_METRICS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_PERIODICS_CHECKS_METRICS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_PERIODICS_CHECKS_METRICS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_PERIODICS_CHECKS_METRICS:
      return initialState
    default:
      return state
  }
}

export default reducers
